// CategoricalDataHistogram.js

import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { ResponsivePie } from '@nivo/pie';
import { DataProvider, useDataSetters, useDataState } from '../../DataContext';

const countClassesInFeatureCollection = (features, columnKey) => {
    const classCount = {};
    features.forEach(feature => {
      const maturityClass = feature.properties[columnKey];
      if (!classCount[maturityClass]) {
        classCount[maturityClass] = 0;
      }
      classCount[maturityClass]++;
    });
    return classCount;
  };

const countClassesInSimpleArray = (dataArray, columnKey) => {
const classCount = {};
dataArray.forEach(data => {
    const maturityClass = data[columnKey];
    if (!classCount[maturityClass]) {
    classCount[maturityClass] = 0;
    }
    classCount[maturityClass]++;
});
return classCount;
};

const formatHistogramData = (classCount, columnKey, maturityClassColors) => {
    return Object.keys(classCount).map((maturityClass, index) => {
      let color = maturityClassColors[maturityClass];
      if (Array.isArray(color)) {
        // Convert the array to an rgba string
        color = `rgba(${color.join(',')})`;
      }
      return {
        label: `${maturityClass}`,
        [columnKey]: classCount[maturityClass],
        color: color || '#000', // use the computed color or fallback to black
      };
    }).sort((a, b) => a.label.localeCompare(b.label));
  }; 

// Function to convert GeoJSON to a format suitable for a class-based histogram
const convertGeojsonToClassBasedHistogramData = (geojson, geojson_nodata, maturityClassColors) => {
    
    const columnKey = 'class_maturity';
    let classCount;
    let isFeatureCollection = geojson.hasOwnProperty('type') && geojson.type === 'FeatureCollection';
  
    if (isFeatureCollection) {
      classCount = countClassesInFeatureCollection(geojson.features, columnKey);
    } else {
      classCount = countClassesInSimpleArray(geojson, columnKey);
    }

    // Count "No Data" from second GeoJSON
    console.log('geojson_nodata', geojson_nodata)
    const noDataCount = geojson_nodata.features.length;

    if (classCount['No Data']) {
      classCount['No Data'] += noDataCount;
    } else {
      classCount['No Data'] = noDataCount;
    }
  
    const histogramData = formatHistogramData(classCount, columnKey, maturityClassColors);
    const totalNumberOfPlants = isFeatureCollection ? geojson.features.length : geojson.length;

    return { histogramData, totalNumberOfPlants };
  };  

  export const CategoricalDataHistogram = ({ geojson, geojson_nodata, maturityClassColors }) => {
    
    const { histogramData, totalNumberOfPlants } = convertGeojsonToClassBasedHistogramData(geojson, geojson_nodata, maturityClassColors);
    console.log('histogramData: ', histogramData);

    // Convert it to a format suitable for the pie chart:
    const pieData = histogramData.map(item => ({
        id: item.label,
        label: item.label,
        value: item.class_maturity,
        color: item.color,
    }));

    const totalPlants = pieData.reduce((acc, curr) => acc + curr.value, 0);

    const CustomPieLayer = ({ width, height }) => {
        return (
            <>
                <text
                    x={width / 2}  // Middle of container
                    y={height / 2} // Middle of container
                    textAnchor="middle"  // Center horizontally
                    dominantBaseline="middle"  // Center vertically
                    style={{
                        fontSize: '15px', // Adjust the font size as needed
                        fontWeight: 'bold',
                    }}
                >
                    Total: {totalPlants} plants
                </text>
            </>
        );
    };
    
    return (
        <div className="histogram-container">
            <div className="centered-label">
                <div style={{ color: 'gray', fontSize: '12px' }}> Potential </div>
                <div style={{ color: 'gray', fontSize: '12px' }}>Productivity: </div> 
                <div style={{ color: 'black', fontSize: '16px' }}>{totalPlants} plants</div>
            </div>
        <ResponsivePie
            data={pieData}
            margin={{ top: 5, right: 5, bottom: 15, left: 5 }}
            colors={d => d.data.color}
            innerRadius={0.6}
            padAngle={1.0}
            cornerRadius={2}
            enableArcLabels={false}
            enableArcLinkLabels={false}
            arcLinkLabelsStraightLength={20}
            isInteractive={true}
            activeOuterRadiusOffset={6}
            tooltip={({ datum }) => (
            <div
                style={{
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                padding: '3px',
                borderRadius: '5px',
                }}
            >
                <b>{datum.id}</b>: {datum.value} plants
            </div>
            )}
        />
        </div>
    );
};
